// TaskTypes.js or in the same file above the Task component
const TaskTypes = {
  STANDARD: 'standard',
  WITH_UPLOAD: 'with_upload',
  // ...other task types
};

export { TaskTypes };